import React, { useState, useEffect, useCallback, useRef } from "react";
import { Row, Col, Form, Card, CardBody } from "react-bootstrap";
import users from "../../../assets/images/life-insurance/user.svg";
import finance from "../../../assets/images/life-insurance/financial.svg";
import demographic from "../../../assets/images/life-insurance/optional-demographic.svg";
import { jsPDF } from "jspdf";
import Logo from "../../../assets/images/life-insurance/logo.png";
import NoIndexSEO from "../../../components/SEO/NoIndexSEO";
import { seoConfig } from "../../../utils/seoConfig";
import { useDispatch, useSelector } from "react-redux";
import "./life-insurance.scss";
import {
  getAllCities,
  getAllStates,
  getViewProfile,
} from "../../../redux/slices/profileSlice";
import {
  calculatorAnalytics,
  downloadPDFThunk,
  fetchLifeInsurance,
} from "../../../redux/slices/lifeinsuranceSlice";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ReactComponent as FiSliders } from "../../../assets/images/filters-icon.svg";
import { ReactComponent as Secutity } from "../../../assets/images/security.svg";
import { ReactComponent as Download } from "../../../assets/images/download.svg";
import { ReactComponent as Mail } from "../../../assets/images/mail.svg";
import { ReactComponent as Save } from "../../../assets/images/save.svg";
import { ReactComponent as SecurityCheck } from "../../../assets/images/security-check.svg";
import { ReactComponent as Calender } from "../../../assets/images/date.svg";
import { ReactComponent as Submit } from "../../../assets/images/submit.svg";
import { ReactComponent as Paper } from "../../../assets/images/paper.svg";
import { ReactComponent as Warning } from "../../../assets/images/warning.svg";
import { ReactComponent as People } from "../../../assets/images/people.svg";
import { ReactComponent as FinancialInfo } from "../../../assets/images/financial-info.svg";
import { ReactComponent as Population } from "../../../assets/images/population-people.svg";
import { ReactComponent as CheckList } from "../../../assets/images/check-list.svg";
import { ReactComponent as Info } from "../../../assets/images/info.svg";
import pdf from "../../../assets/images/life-insurance/Life.pdf";
import {
  activityEnd,
  activityStart,
} from "../../../redux/slices/trackActivitySlice";
import usePageTracking from "../../../hooks/usePageTracking";
import { sessionId } from "../../../redux/slices/cityComparisonSlice";
import PaywallSheet from "../../../components/PaywallSheet";
const quoteSchema = yup.object().shape({
  age: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .nullable()
    .min(18, "Minimum age is 18")
    .max(75, "Maximum age is 75"),

  heightUnit: yup
    .string()
    .oneOf(["ft", "cm"])
    .required(),

  heightFt: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .when("heightUnit", {
      is: "ft",
      then: (schema) =>
        schema
          .required("Feet is required")
          .min(3, "Min 3 feet")
          .max(8, "Max 8 feet"),
      otherwise: (schema) => schema.nullable(),
    }),

  heightIn: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .when("heightUnit", {
      is: "ft",
      then: (schema) =>
        schema
          .required("Inches required")
          .min(0, "Min 0 inches")
          .max(11, "Max 11 inches"),
      otherwise: (schema) => schema.nullable(),
    }),

  heightCm: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .when("heightUnit", {
      is: "cm",
      then: (schema) =>
        schema
          .required("Centimeters required")
          .min(90, "Min 90 cm")
          .max(250, "Max 250 cm"),
      otherwise: (schema) => schema.nullable(),
    }),

  weight: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .nullable()
    .min(30, "Too low")
    .max(500, "Too high"),

  weightUnit: yup
    .string()
    .oneOf(["lbs", "kg"])
    .required(),

  healthCondition: yup.string().required("Health condition is required"),
  occupationRisk: yup.string().required("Occupation risk is required"),
  alcoholUse: yup.string().required("Alcohol use is required"),
  extremeSports: yup.string().required("Required"),

  coverageAmount: yup.number().required("Coverage amount is required"),

  policyTerm: yup.number().oneOf([10, 15, 20, 25, 30], "Invalid term"),

  policyType: yup.string().required("Policy type is required"),
  paymentFrequency: yup.string().required("Payment frequency is required"),

  beneficiariesCount: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .min(1, "At least 1")
    .max(20, "Max 20")
    .nullable(),

  accidentalDeathBenefit: yup.boolean().required(),
  disabilityWaiver: yup.boolean().required(),

  maritalStatus: yup.string().nullable(),
  dependents: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .min(1, "At least 1")
    .max(20, "Max 20")
    .nullable(),

  annualIncome: yup
    .number()
    .min(0)
    .nullable(),

  state: yup.string().required("State is required"),
  city: yup.string().required("City is required"),
  zipCode: yup
    .string()
    .nullable()
    .matches(/^\d{5}$/, "Must be exactly 5 digits")
    .transform((value) => (value === "" ? null : value)),
});

const LifeInsurance = ({ selectedCities }) => {
  const [localCities, setLocalCities] = useState({
    current: { state: null, city: null },
    destination: { state: null, city: null },
  });
  // console.log(selectedCities, "selectedCities");
  // console.log(localCities, "localCities");
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  // console.log(cityOptions, "cityOptions");
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);
  const planSlug = store?.profileItem?.data?.plan?.name?.toLowerCase();
  const authStore = useSelector((state) => state.auth);
  const lifeStore = useSelector((state) => state.lifeInsurance);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showBreakdown, setShowBreakdown] = useState(false);
  const [showDisclosure, setShowDisclosure] = useState(false);

  // Collapsible sections state
  const [expandedSections, setExpandedSections] = useState({
    personal: true,
    health: false,
    financial: false,
  });

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  // Keep old state for backward compatibility
  const [showPersonalInfo, setShowPersonalInfo] = useState(true);
  const [showHealthLifestyle, setShowHealthLifestyle] = useState(false);
  const [showFinancialInfo, setShowFinancialInfo] = useState(false);
  const quote = lifeStore.quote;
  const apiQuote = quote?.quote;
  const bmi = apiQuote?.bmi || 0;
  const stateCode = localCities?.current?.state?.code;
  const [showFilters, setShowFilters] = useState(true);
  const saved = JSON.parse(localStorage.getItem("LifeInsurenceInputs"));
  const analyticsDebounceRef = useRef({});
  const lastChangedRef = useRef(null);
  const [inputs, setInputs] = useState(
    saved || {
      age: 20,
      gender: "male",
      smokingStatus: "no",
      heightFt: 6,
      heightIn: 5,
      heightCm: 100,
      heightUnit: "ft",
      weight: 50,
      weightUnit: "kg",
      healthCondition: "excellent",
      occupationRisk: "low",
      alcoholUse: "moderate",
      extremeSports: "no",
      coverageAmount: 100000,
      policyTerm: 15,
      paymentFrequency: "monthly",
      beneficiariesCount: 1,
      policyType: "term",
      accidentalDeathBenefit: "yes",
      disabilityWaiver: "yes",
      maritalStatus: "single",
      dependents: 1,
      annualIncome: 200000,
      state: "NY",
      city: "New York",
      zipCode: "10014",
    },
  );

  const {
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(quoteSchema),
    mode: "onChange",
    defaultValues: {
      age: "",
      gender: "",
      smokingStatus: "",
      heightUnit: "ft",
      heightFt: "",
      heightIn: "",
      heightCm: "",
      weight: "",
      weightUnit: "lbs",
      healthCondition: "",
      occupationRisk: "",
      alcoholUse: "none",
      extremeSports: "no",
      coverageAmount: "",
      policyTerm: "",
      policyType: "term",
      paymentFrequency: "monthly",
      beneficiariesCount: 1,
      accidentalDeathBenefit: false,
      disabilityWaiver: false,
      maritalStatus: "Single",
      dependents: 0,
      annualIncome: "",
      state: "",
      city: "",
      zipCode: "",
    },
  });

  const [locationData, setLocationData] = useState({
    cities: [],
    zipCodes: [],
    loadingCities: false,
    loadingZips: false,
  });

  const [userEmail, setUserEmail] = useState("  ");
  const handleOpenPdf = () => {
    const pdfUrl = pdf;
    window.open(pdfUrl, "_blank");
  };

  usePageTracking("LIFE_INSURANCE_CALCULATOR");

  useEffect(() => {
    const payload = {
      page_name: "LIFE_INSURANCE_CALCULATOR",
      platform: "web",
    };

    dispatch(activityStart(payload));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(
        activityEnd({
          page_name: "LIFE_INSURANCE_CALCULATOR",
        }),
      );
    };
  }, [dispatch]);


  

  useEffect(() => {
    const userProfileEmail = async () => {
      if (!store.profileItem?.data) {
        const data = await dispatch(getViewProfile());
        const email = data.payload?.profileItem?.data.email;
        setUserEmail(email);
        return;
      }
      const email = store.profileItem?.data.email;
      setUserEmail(email);
    };

    userProfileEmail();
  }, [store.profileItem?.data, dispatch]);

  const calculateBMI = (
    heightFt,
    heightIn,
    heightCm,
    heightUnit,
    weight,
    weightUnit,
  ) => {
    if (!weight) return 0;
    let heightMeters;
    if (heightUnit === "cm") {
      if (!heightCm) return 0;
      heightMeters = Number(heightCm) / 100;
    } else {
      if (!heightFt) return 0;
      const totalInches = Number(heightFt) * 12 + Number(heightIn || 0);
      heightMeters = totalInches * 0.0254;
    }
    const weightKg =
      weightUnit === "kg" ? Number(weight) : Number(weight) * 0.453592;
    return weightKg / (heightMeters * heightMeters);
  };

  const fetchZipCodesForCity = useCallback(async (stateCode, cityName) => {
    if (!stateCode || !cityName) return;

    setLocationData((prev) => ({ ...prev, loadingZips: true, zipCodes: [] }));

    try {
      const response = await fetch(
        `https://api.zippopotam.us/us/${stateCode}/${encodeURIComponent(
          cityName,
        )}`,
      );

      if (response.ok) {
        const data = await response.json();
        const zipCodes = data.places
          ? data.places.map((place) => place["post code"]).sort()
          : [];
        setLocationData({ zipCodes, loadingZips: false });
      } else {
        setLocationData({ zipCodes: [], loadingZips: false });
      }
    } catch (error) {
      console.error("Error fetching ZIP codes:", error);
      setLocationData({ zipCodes: [], loadingZips: false });
    }
  }, []);
  // Convert key to snake_case
  // const toSnakeCase = (str) => {
  //   return str
  //     ?.toString()
  //     .trim()
  //     .toLowerCase()
  //     .replace(/\s+/g, "_")
  //     .replace(/[^\w]/g, "_");
  // };
  const toSnakeCase = (str) => str.replace(/([A-Z])/g, "_$1").toLowerCase();
  // Format value (your required format)
  const formatValue = (val) => {
    if (val === undefined || val === null || val === "") return null;

    if (typeof val === "string") {
      return val
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "_")
        .replace(/[^\w]/g, "_");
    }

    return val;
  };

  // const handleInputChange = useCallback(
  //   (name, value) => {
  //     setInputs((prev) => {
  //       const updatedInputs = {
  //         ...prev,
  //         [name]: value,
  //       };

  //       const session_id = sessionStorage.getItem("comparison_session_id");
  //       if (!session_id) return updatedInputs;

  //       const formattedInputs = Object.entries(updatedInputs).reduce(
  //         (acc, [key, val]) => {
  //           acc[toSnakeCase(key)] = formatValue(val);
  //           return acc;
  //         },
  //         {}
  //       );

  //       dispatch(
  //         calculatorAnalytics({
  //           calculator_type: "life_insurance",
  //           event_type: "input_adjusted",
  //           input_name: toSnakeCase(name),
  //           input_value: formatValue(value),
  //           inputs: formattedInputs,
  //           session_id,
  //           timestamp: new Date().toISOString(),
  //         })
  //       );

  //       return updatedInputs;
  //     });

  //     setValue(name, value, { shouldValidate: true });
  //   },
  //   [dispatch, setValue]
  // );

  useEffect(() => {
    if (!lastChangedRef.current) return;

    const session_id = sessionStorage.getItem("comparison_session_id");
    if (!session_id) return;

    if (analyticsDebounceRef.current) {
      clearTimeout(analyticsDebounceRef.current);
    }

    analyticsDebounceRef.current = setTimeout(() => {
      const { name, value } = lastChangedRef.current;

      dispatch(
        calculatorAnalytics({
          calculator_type: "life_insurance",
          event_type: "input_adjusted",
          input_name: toSnakeCase(name),
          input_value: formatValue(value),
          results_viewed: true,
          session_id,
          timestamp: new Date().toISOString(),
        }),
      );
    }, 1000);

    return () => clearTimeout(analyticsDebounceRef.current);
  }, [inputs, dispatch]);
  // const handleInputChange = useCallback(
  //   (name, value) => {
  //     setInputs((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));

  //     setValue(name, value, { shouldValidate: true });
  //   },
  //   [setInputs, setValue],
  // );
  const handleInputChange = useCallback(
    (name, value) => {
      setInputs((prev) => ({
        ...prev,
        [name]: value,
      }));

      setValue(name, value, { shouldValidate: true });

      // Store only the changed field
      lastChangedRef.current = { name, value };
    },
    [setValue],
  );
  const buildPDFPayload = () => ({
    user: {
      full_name: authStore?.user?.full_name ?? "",
      phone: authStore?.user?.phone ?? "",
      email: authStore?.user?.email ?? "",
    },
    inputs: {
      age: inputs.age,
      gender: inputs.gender,
      smokingStatus: inputs.smokingStatus,
      healthCondition: inputs.healthCondition,
      policyTerm: inputs.policyTerm,
      heightFt: inputs.heightFt,
      heightIn: inputs.heightIn,
      heightCm: inputs.heightCm,
      heightUnit: inputs.heightUnit,
      weight: inputs.weight,
      weightUnit: inputs.weightUnit,
      occupationMultiplier: inputs.occupationRisk,
    },
    quote: {
      quote: {
        coverageAmount: quote?.quote?.coverageAmount ?? 0,
        policyType: quote?.quote?.policyType ?? "",
        premiums: {
          monthly: quote?.quote?.premiums?.monthly ?? 0,
          annual: quote?.quote?.premiums?.annual ?? 0,
        },
      },
    },
    breakdown: {
      basePremium: quote?.breakdown?.basePremium ?? 0,
      annuityValue: quote?.breakdown?.annuityValue ?? 0,
      mortalityRate: quote?.breakdown?.mortalityRate ?? 0,
      multipliers: {
        health: quote?.breakdown?.multipliers?.health ?? 1,
        occupation: quote?.breakdown?.multipliers?.occupation ?? 1,
        lifestyle: quote?.breakdown?.multipliers?.lifestyle ?? 1,
        bmi: quote?.breakdown?.multipliers?.bmi ?? 1,
      },
      addons: quote?.breakdown?.addons ?? 0,
      discountPercent: quote?.breakdown?.discountPercent ?? 0,
    },
  });
  // const downloadPDF = async () => {
  //   const payload = buildPDFPayload();
  //   dispatch(downloadPDFThunk(payload));
  //
  // };
  const handleDownloadClick = () => {
    if (planSlug === "free") {
      setShowExportModal(true); // ❌ block
      return;
    }

    downloadPDF(); // ✅ allow
  };
  const downloadPDF = () => {
    const session_id = sessionStorage.getItem("comparison_session_id");

    if (session_id) {
      dispatch(
        calculatorAnalytics({
          calculator_type: "life_insurance",
          event_type: "results_downloaded",
          session_id,
          timestamp: new Date().toISOString(),
        }),
      );
    }

    const payload = buildPDFPayload();
    dispatch(downloadPDFThunk(payload));
  };

  const sendEmail = () => {
    const session_id = sessionStorage.getItem("comparison_session_id");

    if (session_id) {
      dispatch(
        calculatorAnalytics({
          calculator_type: "life_insurance",
          event_type: "quote_shared_via_email",
          session_id,
          timestamp: new Date().toISOString(),
        }),
      );
    }

    const subject = "Life Insurance Quote";
    const email = "info@mapmypay.com";
    const ccEmail = "Tkwells23@gmail.com";
    // const email = "tirth.strivedge@gmail.com";
    const Mobile = authStore?.user?.phone ?? 0;
    const Customer = authStore?.user?.full_name ?? "";
    const Email = authStore?.user?.email ?? "";

    const body = `
Dear Client,

Your Life Insurance Quote Details:

--------------------------------------------------
| User | ${Customer} 
| Age | ${quote?.quote?.age || ""} 
| Phone | ${Mobile} 
| Email | ${Email} 
| BMI    | ${quote?.quote?.bmi || ""} 
| Gender    | ${lifeStore?.quote?.quote?.gender || ""} 
--------------------------------------------------
| Alcohol Use | ${lifeStore?.quote?.healthFactors?.alcoholUse || ""} 
| Health Condition    | ${lifeStore?.quote?.healthFactors?.healthCondition ||
      ""} 
| Smoking Status    | ${lifeStore?.quote?.healthFactors?.smokingStatus} 
| Occupation Risk    | ${lifeStore?.quote?.healthFactors?.occupationRisk} 
--------------------------------------------------
| Annual Income | ${lifeStore?.quote?.discounts?.annualIncome || ""} 
| Health Lifestyle Discount    | ${lifeStore?.quote?.discounts
      ?.healthyLifestyleDiscount || false} 
| Smoking Status    | ${lifeStore?.quote?.discounts?.loyaltyDiscount} 
| Occupation Risk    | ${lifeStore?.quote?.discounts?.maritalStatus} 
| Occupation Risk    | ${lifeStore?.quote?.discounts?.multiPolicyDiscount} 
--------------------------------------------------
| Coverage Amount | ${quote?.quote?.coverageAmount?.toLocaleString("en-US") ||
      "0.00"} 
| Policy Type     | ${quote?.quote?.policyType || "Not selected"} 
| Policy Term     | ${inputs.policyTerm} years 
--------------------------------------------------
| Annual Premium  | ${quote?.quote?.premiums?.annual?.toLocaleString("en-US") ||
      "0.00"} 
| Monthly Premium | ${quote?.quote?.premiums?.monthly?.toLocaleString(
      "en-US",
    ) || "0.00"} 
| Quarterly Premium | ${quote?.quote?.premiums?.quarterly?.toLocaleString(
      "en-US",
    ) || "0.00"} 
--------------------------------------------------
| Net Single Premium  | ${lifeStore?.quote?.breakdown?.basePremium?.toLocaleString(
      "en-US",
    ) || "0.00"} 
| Annuity Value  | ${lifeStore?.quote?.breakdown?.annuityValue?.toLocaleString(
      "en-US",
    ) || "0.00"} 
| Mortality Rate | ${lifeStore?.quote?.breakdown?.mortalityRate?.toLocaleString(
      "en-US",
    ) || "0.00"} 
--------------------------------------------------
| Health Multiplier | ${lifeStore?.quote?.breakdown?.multipliers?.health?.toLocaleString(
      "en-US",
    ) || "0.00"} 
| Occupation Multiplier	| ${lifeStore?.quote?.breakdown?.multipliers?.occupation?.toLocaleString(
      "en-US",
    ) || "0.00"} 
| Lifestyle Multiplier | ${lifeStore?.quote?.breakdown?.multipliers?.lifestyle?.toLocaleString(
      "en-US",
    ) || "0.00"} 
| BMI Multiplier | ${lifeStore?.quote?.breakdown?.multipliers?.bmi?.toLocaleString(
      "en-US",
    ) || "0.00"} 
| Add Ons | ${lifeStore?.quote?.breakdown?.addons?.toLocaleString("en-US") ||
      "0.00"} 
| Discounts | -${lifeStore?.quote?.breakdown?.discountPercent?.toLocaleString(
      "en-US",
    ) || "0.00"}% 
| Annual Premium | ${lifeStore?.quote?.quote?.premiums?.annual?.toLocaleString(
      "en-US",
    ) || "0.00"} 
--------------------------------------------------

Best regards,
Map My Pay
  `;

    window.location.href = `mailto:${email}?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(body)}`;
  };

  const sendEmailCompany = () => {
    const session_id = sessionStorage.getItem("comparison_session_id");

    if (session_id) {
      dispatch(
        calculatorAnalytics({
          calculator_type: "life_insurance",
          event_type: "insurance_quote_submitted",
          session_id,
          timestamp: new Date().toISOString(),
        }),
      );
    }

    const subject = "Life Insurance Quote";
    const email = "info@mapmypay.com";
    const ccEmail = "Tkwells23@gmail.com";
    const Mobile = authStore?.user?.phone ?? 0;
    const Email = authStore?.user?.email ?? "";
    const Customer = authStore?.user?.full_name ?? "";
    // const email = "sumerpal@gmail.com";
    const body = `Dear Client,

Your Life Insurance Quote Details:

--------------------------------------------------
| User | ${Customer} 
| Age | ${quote?.quote?.age || ""} 
| Phone | ${Mobile} 
| Email | ${Email} 
| BMI    | ${quote?.quote?.bmi || ""} 
| Gender    | ${lifeStore?.quote?.quote?.gender || ""} 
--------------------------------------------------
| Alcohol Use | ${lifeStore?.quote?.healthFactors?.alcoholUse || ""} 
| Health Condition    | ${lifeStore?.quote?.healthFactors?.healthCondition ||
      ""} 
| Smoking Status    | ${lifeStore?.quote?.healthFactors?.smokingStatus} 
| Occupation Risk    | ${lifeStore?.quote?.healthFactors?.occupationRisk} 
--------------------------------------------------
| Annual Income | ${lifeStore?.quote?.discounts?.annualIncome || ""} 
| Health Lifestyle Discount    | ${lifeStore?.quote?.discounts
      ?.healthyLifestyleDiscount || false} 
| Smoking Status    | ${lifeStore?.quote?.discounts?.loyaltyDiscount} 
| Occupation Risk    | ${lifeStore?.quote?.discounts?.maritalStatus} 
| Occupation Risk    | ${lifeStore?.quote?.discounts?.multiPolicyDiscount} 
--------------------------------------------------
| Coverage Amount | ${quote?.quote?.coverageAmount?.toLocaleString("en-US") ||
      "0.00"} 
| Policy Type     | ${quote?.quote?.policyType || "Not selected"} 
| Policy Term     | ${inputs.policyTerm} years 
--------------------------------------------------
| Annual Premium  | ${quote?.quote?.premiums?.annual?.toLocaleString("en-US") ||
      "0.00"} 
| Monthly Premium | ${quote?.quote?.premiums?.monthly?.toLocaleString(
      "en-US",
    ) || "0.00"} 
| Quarterly Premium | ${quote?.quote?.premiums?.quarterly?.toLocaleString(
      "en-US",
    ) || "0.00"} 
--------------------------------------------------
| Net Single Premium  | ${lifeStore?.quote?.breakdown?.basePremium?.toLocaleString(
      "en-US",
    ) || "0.00"} 
| Annuity Value  | ${lifeStore?.quote?.breakdown?.annuityValue?.toLocaleString(
      "en-US",
    ) || "0.00"} 
| Mortality Rate | ${lifeStore?.quote?.breakdown?.mortalityRate?.toLocaleString(
      "en-US",
    ) || "0.00"} 
--------------------------------------------------
| Health Multiplier | ${lifeStore?.quote?.breakdown?.multipliers?.health?.toLocaleString(
      "en-US",
    ) || "0.00"} 
| Occupation Multiplier	| ${lifeStore?.quote?.breakdown?.multipliers?.occupation?.toLocaleString(
      "en-US",
    ) || "0.00"} 
| Lifestyle Multiplier | ${lifeStore?.quote?.breakdown?.multipliers?.lifestyle?.toLocaleString(
      "en-US",
    ) || "0.00"} 
| BMI Multiplier | ${lifeStore?.quote?.breakdown?.multipliers?.bmi?.toLocaleString(
      "en-US",
    ) || "0.00"} 
| Add Ons | ${lifeStore?.quote?.breakdown?.addons?.toLocaleString("en-US") ||
      "0.00"} 
| Discounts | -${lifeStore?.quote?.breakdown?.discountPercent?.toLocaleString(
      "en-US",
    ) || "0.00"}% 
| Annual Premium | ${lifeStore?.quote?.quote?.premiums?.annual?.toLocaleString(
      "en-US",
    ) || "0.00"} 
--------------------------------------------------

Best regards,
Map My Pay`;

    // window.location.href = `mailto:${email}?subject=${encodeURIComponent(
    //   subject
    // )}&body=${encodeURIComponent(body)}`;
    const mailtoLink =
      `mailto:${encodeURIComponent(email)}` +
      `?cc=${encodeURIComponent(ccEmail)}` +
      `&subject=${encodeURIComponent(subject)}` +
      `&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink;
  };

  useEffect(() => {
    if (inputs.state && inputs.city) {
      fetchZipCodesForCity(inputs.state.toLowerCase(), inputs.city.trim());
      handleInputChange("zipCode", "");
    } else {
      setLocationData({ zipCodes: [], loadingZips: false });
      handleInputChange("zipCode", "");
    }
  }, [inputs.state, inputs.city, fetchZipCodesForCity, handleInputChange]);
  useEffect(() => {
    const profile = store?.profileItem?.data;
    if (profile) {
      setLocalCities({
        current: {
          state: {
            value: profile?.living_state ? profile?.living_state : "",
            label: profile?.living_state_name || "",
            code: profile?.living_state || "",
          },
          city: {
            value: profile?.city || "",
            label: profile?.city || "",
          },
        },
        destination: {
          state: {
            value: profile?.work_state ? profile?.work_state : "",
            label: profile?.work_state_name || "",
            code: profile?.work_state || "",
          },
          city: {
            value: profile?.work_city || "",
            label: profile?.work_city || "",
          },
        },
      });
    }
  }, [store?.profileItem]);
  useEffect(() => {
    localStorage.setItem("LifeInsurenceInputs", JSON.stringify(inputs));

    // Add 2-second debounce for API call
    const debounceTimer = setTimeout(() => {
      dispatch(fetchLifeInsurance(inputs));
      // console.log(inputs, "inputs in life insurance page");
    }, 2000); // 2-second debounce

    // Cleanup function to clear timeout if inputs change before 2 seconds
    return () => clearTimeout(debounceTimer);
  }, [inputs, dispatch]);

  useEffect(() => {
    dispatch(getAllStates());
  }, [dispatch]);

  useEffect(() => {
    if (stateCode) {
      dispatch(
        getAllCities({
          search_state: stateCode,
        }),
      );
    }
  }, [dispatch, stateCode]);

  useEffect(() => {
    if (localCities?.destination?.state?.code) {
      dispatch(
        getAllCities({
          search_state: localCities.destination.state.code,
        }),
      );
    }
  }, [dispatch, localCities?.destination?.state?.code]);

  useEffect(() => {
    if (store?.stateItems?.data?.states) {
      const options = store?.stateItems?.data?.states?.map((state) => ({
        value: state.id,
        label: state.state_full_name,
        code: state.state,
      }));
      setStateOptions(options);
    }
    if (store?.cityItems?.data?.cities) {
      const options = store.cityItems.data.cities.map((cityObj, index) => ({
        value: cityObj.city,
        label: cityObj.city,
      }));
      setCityOptions(options);
    }
  }, [store?.stateItems, store?.cityItems]);

  const user = useSelector((state) => state.auth?.user);

  useEffect(() => {
    if (!user) {
      sessionStorage.removeItem("comparison_session_id");
      sessionStorage.removeItem("session_expiry");

      console.log("🧹 Session cleared on logout");
    }
  }, [user]);

  useEffect(() => {
    if (!user?.id) return;

    const existingSession = sessionStorage.getItem("comparison_session_id");
    const expiry = sessionStorage.getItem("session_expiry");

    // 🔥 Check if valid session exists
    if (existingSession && expiry && Date.now() < Number(expiry)) {
      return;
    }

    // const token = localStorage.getItem("authToken");

    // dispatch(
    //   sessionId({
    //     user_id: user.id,
    //     access_token: token,
    //   }),
    dispatch(sessionId()).then((res) => {
      const data = res.payload?.data;

      if (data?.session_id) {
        sessionStorage.setItem("comparison_session_id", data.session_id);

        // 🔥 store expiry (important)
        const expiryTime = Date.now() + data.expires_in * 1000;
        sessionStorage.setItem("session_expiry", expiryTime);
      }
    });
  }, [user]);
  useEffect(() => {
    const session_id = sessionStorage.getItem("comparison_session_id");
    if (!session_id) return;

    dispatch(
      calculatorAnalytics({
        calculator_type: "life_insurance",
        event_type: "life_insurance_calculator_view",
        session_id,
        timestamp: new Date().toISOString(),
      }),
    );
  }, [dispatch]);
  const handleSaveScenario = () => {
    const session_id = sessionStorage.getItem("comparison_session_id");
    if (!session_id) return;

    dispatch(
      calculatorAnalytics({
        calculator_type: "life_insurance",
        event_type: "calculator_scenario_saved",
        session_id,
        timestamp: new Date().toISOString(),
      }),
    );

    localStorage.setItem("HomeInsurenceInputs", JSON.stringify(inputs));
  };
  return (
    <>
      <div className="filters-content-main life-insurance-layout">
        <NoIndexSEO title={seoConfig.lifeInsurance.title} />
        <Row>
          <div className="filter-sidebar">
            <Card className="filter-container mb-0">
              <div className="inner-sub-sub-title">
                <div className="header-content">
                  <div className="inner-sub-title">
                    Life Insurance Quote Generator
                  </div>
                  <div className="subtitle-text">
                    Fill in your details to get an accurate life insurance quote
                  </div>

                  {/* Progress Steps - Hidden on mobile when filters closed */}
                  {(showFilters || window.innerWidth > 991) && (
                    <div className="progress-steps">
                      <div
                        className={`step ${
                          expandedSections.personal ||
                          expandedSections.health ||
                          expandedSections.financial
                            ? "completed"
                            : ""
                        }`}
                      >
                        <div
                          className={`step-number ${
                            expandedSections.personal
                              ? "active"
                              : expandedSections.health ||
                                expandedSections.financial
                              ? "completed"
                              : ""
                          }`}
                        >
                          1
                        </div>
                        <div
                          className={`step-label ${
                            expandedSections.personal
                              ? "active"
                              : expandedSections.health ||
                                expandedSections.financial
                              ? "completed"
                              : ""
                          }`}
                        >
                          Personal Info
                        </div>
                      </div>
                      <div
                        className={`step ${
                          expandedSections.health || expandedSections.financial
                            ? "completed"
                            : ""
                        }`}
                      >
                        <div
                          className={`step-number ${
                            expandedSections.health
                              ? "active"
                              : expandedSections.financial
                              ? "completed"
                              : ""
                          }`}
                        >
                          2
                        </div>
                        <div
                          className={`step-label ${
                            expandedSections.health
                              ? "active"
                              : expandedSections.financial
                              ? "completed"
                              : ""
                          }`}
                        >
                          Health & Lifestyle
                        </div>
                      </div>
                      <div
                        className={`step ${
                          expandedSections.financial ? "completed" : ""
                        }`}
                      >
                        <div
                          className={`step-number ${
                            expandedSections.financial ? "active" : ""
                          }`}
                        >
                          3
                        </div>
                        <div
                          className={`step-label ${
                            expandedSections.financial ? "active" : ""
                          }`}
                        >
                          Financial Info
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <button
                  className="filter-toggle-btn"
                  onClick={() => setShowFilters(!showFilters)}
                >
                  <FiSliders />
                </button>
              </div>

              <div className={`filter ${showFilters ? "open" : "closed"}`}>
                {/* Personal Information Section - Collapsible */}
                <button
                  className={`section-header ${
                    expandedSections.personal ? "expanded" : ""
                  }`}
                  onClick={() => toggleSection("personal")}
                >
                  <div className="section-title">
                    <People />
                    Personal Information
                  </div>
                  <svg
                    className={`chevron ${
                      expandedSections.personal ? "expanded" : ""
                    }`}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z" />
                  </svg>
                </button>

                {expandedSections.personal && (
                  <div className="section-content">
                    <div className="sidebar-form">
                      <form>
                        {/* Age and Gender Row */}
                        <div className="group-with-error">
                          <div className="form-group age-gender-row">
                            <div className="age-group">
                              <label>Age</label>
                              <div className="age-input-group">
                                <input
                                  type="number"
                                  value={inputs.age}
                                  onChange={(e) =>
                                    handleInputChange("age", e.target.value)
                                  }
                                  placeholder="20"
                                />
                                <span>years</span>
                              </div>
                            </div>
                            <div className="gender-group">
                              <label>Gender</label>
                              <select
                                value={inputs.gender}
                                onChange={(e) =>
                                  handleInputChange("gender", e.target.value)
                                }
                              >
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                              </select>
                            </div>
                          </div>
                          {(errors.age || errors.gender) && (
                            <div className="error-message">
                              {errors.age?.message || errors.gender?.message}
                            </div>
                          )}
                        </div>

                        <div className="group-with-error">
                          <div className="form-group two-col">
                            <label>Smoker Status</label>
                            <select
                              value={inputs.smokingStatus}
                              onChange={(e) =>
                                handleInputChange(
                                  "smokingStatus",
                                  e.target.value,
                                )
                              }
                            >
                              <option value="no">No</option>
                              <option value="yes">Yes</option>
                            </select>
                          </div>
                          {errors.smokingStatus && (
                            <div className="error-message">
                              {errors.smokingStatus.message}
                            </div>
                          )}
                        </div>

                        {/* Height and Weight Row */}
                        <div className="group-with-error">
                          <div className="form-group age-gender-row">
                            <div className="age-group">
                              <label>Height</label>
                              <div className="height-group">
                                {inputs.heightUnit === "ft" ? (
                                  <>
                                    <input
                                      type="number"
                                      value={inputs.heightFt}
                                      onChange={(e) =>
                                        handleInputChange(
                                          "heightFt",
                                          e.target.value,
                                        )
                                      }
                                      placeholder="6"
                                      min="3"
                                      max="11"
                                    />
                                    <input
                                      type="number"
                                      value={inputs.heightIn}
                                      onChange={(e) =>
                                        handleInputChange(
                                          "heightIn",
                                          e.target.value,
                                        )
                                      }
                                      placeholder="5"
                                      min="0"
                                      max="11"
                                    />
                                  </>
                                ) : (
                                  <input
                                    type="number"
                                    value={inputs.heightCm}
                                    onChange={(e) =>
                                      handleInputChange(
                                        "heightCm",
                                        e.target.value,
                                      )
                                    }
                                    placeholder="Centimeters"
                                    min="100"
                                    max="250"
                                  />
                                )}
                                <select
                                  value={inputs.heightUnit}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "heightUnit",
                                      e.target.value,
                                    )
                                  }
                                >
                                  <option value="ft">Ft/In</option>
                                  <option value="cm">Cm</option>
                                </select>
                              </div>
                            </div>
                            <div className="gender-group">
                              <label>Weight</label>
                              <div className="height-group">
                                <input
                                  type="number"
                                  value={inputs.weight}
                                  onChange={(e) =>
                                    handleInputChange("weight", e.target.value)
                                  }
                                  placeholder="50"
                                />
                                <select
                                  value={inputs.weightUnit}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "weightUnit",
                                      e.target.value,
                                    )
                                  }
                                >
                                  <option value="lbs">Lbs</option>
                                  <option value="kg">Kg</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          {(errors.heightFt ||
                            errors.heightIn ||
                            errors.heightCm ||
                            errors.weight) && (
                            <div className="error-message">
                              {errors.heightFt?.message ||
                                errors.heightIn?.message ||
                                errors.heightCm?.message ||
                                errors.weight?.message}
                            </div>
                          )}
                        </div>

                        {/* Health Condition and Occupation Risk Row */}
                        <div className="group-with-error">
                          <div className="form-group age-gender-row">
                            <div className="age-group">
                              <label>Health Condition</label>
                              <select
                                value={inputs.healthCondition}
                                onChange={(e) =>
                                  handleInputChange(
                                    "healthCondition",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="excellent">Excellent</option>
                                <option value="good">Good</option>
                                <option value="average">Average</option>
                                <option value="poor">Poor</option>
                              </select>
                            </div>
                            <div className="gender-group">
                              <label>Occupation Risk</label>
                              <select
                                value={inputs.occupationRisk}
                                onChange={(e) =>
                                  handleInputChange(
                                    "occupationRisk",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="low">Low</option>
                                <option value="medium">Medium</option>
                                <option value="high">High</option>
                              </select>
                            </div>
                          </div>
                          {(errors.healthCondition ||
                            errors.occupationRisk) && (
                            <div className="error-message">
                              {errors.healthCondition?.message ||
                                errors.occupationRisk?.message}
                            </div>
                          )}
                        </div>

                        {/* Alcohol Use and Extreme Sports Row */}
                        <div className="group-with-error">
                          <div className="form-group age-gender-row">
                            <div className="age-group">
                              <label>Alcohol Use</label>
                              <select
                                value={inputs.alcoholUse}
                                onChange={(e) =>
                                  handleInputChange(
                                    "alcoholUse",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="none">None</option>
                                <option value="moderate">Moderate</option>
                                <option value="heavy">Heavy</option>
                              </select>
                            </div>
                            <div className="gender-group">
                              <label>Extreme Sports</label>
                              <select
                                value={inputs.extremeSports}
                                onChange={(e) =>
                                  handleInputChange(
                                    "extremeSports",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="no">No</option>
                                <option value="yes">Yes</option>
                              </select>
                            </div>
                          </div>
                          {(errors.alcoholUse || errors.extremeSports) && (
                            <div className="error-message">
                              {errors.alcoholUse?.message ||
                                errors.extremeSports?.message}
                            </div>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                )}

                {/* Financial & Policy Information Section - Collapsed */}
                <button
                  className={`section-header ${
                    expandedSections.health ? "expanded" : ""
                  }`}
                  onClick={() => toggleSection("health")}
                >
                  <div className="section-title">
                    <FinancialInfo />
                    Financial & Policy Information
                  </div>
                  <svg
                    className={`chevron ${
                      expandedSections.health ? "expanded" : ""
                    }`}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z" />
                  </svg>
                </button>

                {expandedSections.health && (
                  <div className="section-content">
                    <div className="sidebar-form">
                      <form>
                        {/* Coverage Amount and Policy Type Row */}
                        <div className="group-with-error">
                          <div className="form-group age-gender-row">
                            <div className="age-group">
                              <label>Coverage Amount</label>
                              <select
                                value={inputs.coverageAmount}
                                onChange={(e) =>
                                  handleInputChange(
                                    "coverageAmount",
                                    parseInt(e.target.value),
                                  )
                                }
                              >
                                <option value={50000}>$50,000</option>
                                <option value={100000}>$100,000</option>
                                <option value={250000}>$250,000</option>
                                <option value={500000}>$500,000</option>
                                <option value={750000}>$750,000</option>
                                <option value={1000000}>$1,000,000</option>
                                <option value={1500000}>$1,500,000</option>
                                <option value={2000000}>$2,000,000</option>
                              </select>
                            </div>
                            <div className="gender-group">
                              <label>Policy Type</label>
                              <select
                                value={inputs.policyType}
                                onChange={(e) =>
                                  handleInputChange(
                                    "policyType",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="term">Term Life</option>
                                <option value="whole">Whole Life</option>
                                <option value="universal">
                                  Universal Life
                                </option>
                              </select>
                            </div>
                          </div>
                          {(errors.coverageAmount || errors.policyType) && (
                            <div className="error-message">
                              {errors.coverageAmount?.message ||
                                errors.policyType?.message}
                            </div>
                          )}
                        </div>

                        {/* Policy Term and Payment Frequency Row */}
                        <div className="group-with-error">
                          <div className="form-group age-gender-row">
                            <div className="age-group">
                              <label>Policy Term</label>
                              <select
                                value={inputs.policyTerm}
                                onChange={(e) =>
                                  handleInputChange(
                                    "policyTerm",
                                    parseInt(e.target.value),
                                  )
                                }
                              >
                                <option value={10}>10 years</option>
                                <option value={15}>15 years</option>
                                <option value={20}>20 years</option>
                                <option value={25}>25 years</option>
                                <option value={30}>30 years</option>
                              </select>
                            </div>
                            <div className="gender-group">
                              <label>Payment Frequency</label>
                              <select
                                value={inputs.paymentFrequency}
                                onChange={(e) =>
                                  handleInputChange(
                                    "paymentFrequency",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="monthly">Monthly</option>
                                <option value="quarterly">Quarterly</option>
                                <option value="semi-annual">Semi-Annual</option>
                                <option value="annual">Annual</option>
                              </select>
                            </div>
                          </div>
                          {(errors.policyTerm || errors.paymentFrequency) && (
                            <div className="error-message">
                              {errors.policyTerm?.message ||
                                errors.paymentFrequency?.message}
                            </div>
                          )}
                        </div>

                        {/* Annual Income */}
                        <div className="group-with-error">
                          <div className="form-group two-col">
                            <label>Annual Income</label>
                            <input
                              type="number"
                              value={inputs.annualIncome}
                              onChange={(e) =>
                                handleInputChange(
                                  "annualIncome",
                                  e.target.value,
                                )
                              }
                              placeholder="200000"
                            />
                          </div>
                          {errors.annualIncome && (
                            <div className="error-message">
                              {errors.annualIncome.message}
                            </div>
                          )}
                        </div>

                        {/* Beneficiaries Count */}
                        <div className="group-with-error">
                          <div className="form-group two-col">
                            <label>Number of Beneficiaries</label>
                            <input
                              type="number"
                              value={inputs.beneficiariesCount}
                              onChange={(e) =>
                                handleInputChange(
                                  "beneficiariesCount",
                                  parseInt(e.target.value),
                                )
                              }
                              placeholder="1"
                              min="1"
                              max="20"
                            />
                          </div>
                          {errors.beneficiariesCount && (
                            <div className="error-message">
                              {errors.beneficiariesCount.message}
                            </div>
                          )}
                        </div>

                        {/* Add-ons Row */}
                        <div className="group-with-error">
                          <div className="form-group age-gender-row">
                            <div className="age-group">
                              <label>Accidental Death Benefit</label>
                              <select
                                value={inputs.accidentalDeathBenefit}
                                onChange={(e) =>
                                  handleInputChange(
                                    "accidentalDeathBenefit",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                              </select>
                            </div>
                            <div className="gender-group">
                              <label>Disability Waiver</label>
                              <select
                                value={inputs.disabilityWaiver}
                                onChange={(e) =>
                                  handleInputChange(
                                    "disabilityWaiver",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                              </select>
                            </div>
                          </div>
                          {(errors.accidentalDeathBenefit ||
                            errors.disabilityWaiver) && (
                            <div className="error-message">
                              {errors.accidentalDeathBenefit?.message ||
                                errors.disabilityWaiver?.message}
                            </div>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                )}

                {/* Optional Demographic Info Section - Collapsed */}
                <button
                  className={`section-header ${
                    expandedSections.financial ? "expanded" : ""
                  }`}
                  onClick={() => toggleSection("financial")}
                >
                  <div className="section-title">
                    <Population />
                    Optional Demographic Info
                  </div>
                  <svg
                    className={`chevron ${
                      expandedSections.financial ? "expanded" : ""
                    }`}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z" />
                  </svg>
                </button>

                {expandedSections.financial && (
                  <div className="section-content">
                    <div className="sidebar-form">
                      <form>
                        {/* Marital Status and Dependents Row */}
                        <div className="group-with-error">
                          <div className="form-group age-gender-row">
                            <div className="age-group">
                              <label>Marital Status</label>
                              <select
                                value={inputs.maritalStatus}
                                onChange={(e) =>
                                  handleInputChange(
                                    "maritalStatus",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="single">Single</option>
                                <option value="married">Married</option>
                                <option value="divorced">Divorced</option>
                                <option value="widowed">Widowed</option>
                              </select>
                            </div>
                            <div className="gender-group">
                              <label>Number of Dependents</label>
                              <input
                                type="number"
                                value={inputs.dependents}
                                onChange={(e) =>
                                  handleInputChange(
                                    "dependents",
                                    parseInt(e.target.value),
                                  )
                                }
                                placeholder="1"
                                min="0"
                                max="20"
                              />
                            </div>
                          </div>
                          {(errors.maritalStatus || errors.dependents) && (
                            <div className="error-message">
                              {errors.maritalStatus?.message ||
                                errors.dependents?.message}
                            </div>
                          )}
                        </div>

                        {/* State and City Row */}
                        <div className="group-with-error">
                          <div className="form-group age-gender-row">
                            <div className="age-group">
                              <label>State</label>
                              <select
                                value={inputs.state}
                                onChange={(e) => {
                                  const selectedState = stateOptions.find(
                                    (opt) => opt.code === e.target.value
                                  );
                                  handleInputChange("state", e.target.value);
                                  // Clear city when state changes
                                  handleInputChange("city", "");
                                  if (selectedState) {
                                    dispatch(getAllCities({
                                      search_state: selectedState.code
                                    }));
                                  }
                                }}
                              >
                                <option value="">Select State</option>
                                {stateOptions.map((state) => (
                                  <option key={state.code} value={state.code}>
                                    {state.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="gender-group">
                              <label>City</label>
                              <select
                                value={inputs.city}
                                onChange={(e) =>
                                  handleInputChange("city", e.target.value)
                                }
                                disabled={!inputs.state}
                              >
                                <option value="">Select City</option>
                                {cityOptions.map((city) => (
                                  <option key={city.value} value={city.value}>
                                    {city.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          {(errors.state || errors.city) && (
                            <div className="error-message">
                              {errors.state?.message || errors.city?.message}
                            </div>
                          )}
                        </div>

                        {/* ZIP Code */}
                        <div className="group-with-error">
                          <div className="form-group two-col">
                            <label>ZIP Code</label>
                            <select
                              value={inputs.zipCode}
                              onChange={(e) =>
                                handleInputChange("zipCode", e.target.value)
                              }
                            >
                              <option value="">Select ZIP Code</option>
                              <option value="10001">10001</option>
                              <option value="10002">10002</option>
                              <option value="10003">10003</option>
                              <option value="10004">10004</option>
                              <option value="10005">10005</option>
                              <option value="10006">10006</option>
                              <option value="10007">10007</option>
                              <option value="10008">10008</option>
                              <option value="10009">10009</option>
                              <option value="10010">10010</option>
                              <option value="10011">10011</option>
                              <option value="10012">10012</option>
                              <option value="10013">10013</option>
                              <option value="10014">10014</option>
                              <option value="10015">10015</option>
                            </select>
                          </div>
                          {errors.zipCode && (
                            <div className="error-message">
                              {errors.zipCode.message}
                            </div>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                )}

                {/* Security Message */}
                <div className="security-message">
                  <svg
                    className="security-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12 2L3 7V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V7L12 2ZM10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z" />
                  </svg>
                  <div className="security-content">
                    <div className="security-title">
                      Your information is safe with us
                    </div>
                    <div className="security-text">
                      We use industry standard encryption to protect your data
                      and keep it private.
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>

          <div className="filter-content">
            <div className="life-insurance-three-cards">
              {/* Card 1: Your Estimated Premium */}
              <div className="premium-card">
                <div className="premium-summary-card">
                  <div className="premium-header">
                    <div className="premium-info">
                      <h3>Your Estimated Premium</h3>
                      <p>(Monthly)</p>
                      <div className="premium-amount">
                        $
                        {quote?.quote?.premiums?.monthly?.toLocaleString(
                          "en-US",
                        ) || "0.00"}
                      </div>
                      <div className="premium-breakdown-text">
                        $
                        {quote?.quote?.premiums?.quarterly?.toLocaleString(
                          "en-US",
                        ) || "0.00"}{" "}
                        / Quarterly • $
                        {quote?.quote?.premiums?.annual?.toLocaleString(
                          "en-US",
                        ) || "0.00"}{" "}
                        / Yearly
                      </div>
                    </div>
                    <div className="shield-icon">
                      {/* <svg
                        width="80"
                        height="80"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 2L3 7V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V7L12 2ZM10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z"
                          fill="white"
                          fillOpacity="0.9"
                        />
                      </svg> */}
                      <Secutity />
                    </div>
                  </div>
                </div>

                {/* Key Details Grid */}
                <div className="details-grid">
                  <div className="detail-item">
                    <div className="detail-icon">
                      {/* <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 2L3 7V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V7L12 2Z"
                          fill="#2196F3"
                        />
                      </svg> */}
                      <SecurityCheck />
                    </div>
                    <div className="detail-content">
                      <span className="detail-label">Coverage Amount</span>
                      <span className="detail-value">
                        $
                        {quote?.quote?.coverageAmount?.toLocaleString(
                          "en-US",
                        ) || "0"}
                      </span>
                    </div>
                  </div>

                  <div className="detail-item">
                    <div className="detail-icon">
                      {/* <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 11H7V9H9V11ZM13 11H11V9H13V11ZM17 11H15V9H17V11ZM19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V9H19V20Z"
                          fill="#2196F3"
                        />
                      </svg> */}
                      <Paper />
                    </div>
                    <div className="detail-content">
                      <span className="detail-label">Policy Type</span>
                      <span className="detail-value">
                        {quote?.quote?.policyType || "Term Life"}
                      </span>
                    </div>
                  </div>

                  <div className="detail-item">
                    <div className="detail-icon">
                      {/* <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
                          fill="#2196F3"
                        />
                      </svg> */}
                      <Calender />
                    </div>
                    <div className="detail-content">
                      <span className="detail-label">Policy Term</span>
                      <span className="detail-value">
                        {inputs.policyTerm} years
                      </span>
                    </div>
                  </div>

                  <div className="detail-item bmi-warning">
                    <div className="detail-icon">
                      {/* <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z"
                          fill="#f44336"
                        />
                      </svg> */}
                      <Warning />
                    </div>
                    <div className="detail-content">
                      <div className="bmi-content">
                        <span className="detail-label">BMI</span>
                        <span className="detail-value">
                          {quote?.quote?.bmi?.toFixed(2) || "13.07"}
                        </span>
                        <span className="bmi-category">
                          {quote?.quote?.bmiCategory || "Severely Underweight"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="action-buttons">
                  <button
                    className="btn-submit-quote"
                    onClick={sendEmailCompany}
                  >
                    {/* <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z"
                        fill="white"
                      />
                    </svg> */}
                    <Submit />
                    Submit Quote
                  </button>

                  <div className="secondary-actions">
                    <button
                      className="btn-secondary-action"
                      onClick={handleSaveScenario}
                    >
                      {/* <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3ZM19 19H5V5H16.17L19 7.83V19ZM12 12C10.34 12 9 13.34 9 15S10.34 18 12 18 15 16.66 15 15 13.66 12 12 12ZM6 6H15V10H6V6Z"
                          fill="currentColor"
                        />
                      </svg> */}
                      <Save />
                      Save Draft
                    </button>

                    <button
                      className="btn-secondary-action"
                      onClick={handleDownloadClick}
                    >
                      {/* <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z"
                          fill="currentColor"
                        />
                      </svg> */}
                      <Download />
                      Download PDF
                    </button>

                    <button
                      className="btn-secondary-action"
                      onClick={sendEmail}
                    >
                      {/* <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
                          fill="currentColor"
                        />
                      </svg> */}
                      <Mail />
                      Send via Email
                    </button>
                  </div>
                </div>
              </div>

              {/* Card 2: Premium Breakdown */}
              <div className="breakdown-card">
                <div
                  className="card-header"
                  onClick={() => setShowBreakdown(!showBreakdown)}
                >
                  <div className="card-title">
                    {/* <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 13H11V11H3V13ZM3 17H11V15H3V17ZM3 9H11V7H3V9ZM16 13H21V11H16V13ZM16 17H21V15H16V17ZM16 7V9H21V7H16ZM13 7V17H14V7H13Z"
                        fill="currentColor"
                      />
                    </svg> */}
                    <CheckList />
                    Premium Breakdown
                  </div>
                  <svg
                    className={`chevron ${showBreakdown ? "expanded" : ""}`}
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>

                {showBreakdown && (
                  <div className="card-content">
                    <div className="breakdown-table-container">
                      <div className="breakdown-table">
                        <div className="breakdown-header">
                          <div className="header-item">Component</div>
                          <div className="header-item center">Value</div>
                          <div className="header-item">Impact</div>
                        </div>

                        <div className="breakdown-row">
                          <div className="component">
                            Net Single Premium (NSP)
                          </div>
                          <div className="value">
                            $
                            {quote?.breakdown?.basePremium?.toLocaleString(
                              "en-US",
                            ) || "623.99"}
                          </div>
                          <div className="impact">
                            Present value of death benefit
                          </div>
                        </div>
                        <div className="breakdown-row">
                          <div className="component">Annuity Value (äx:n)</div>
                          <div className="value">
                            $
                            {quote?.breakdown?.annuityValue?.toLocaleString(
                              "en-US",
                            ) || "11,524"}
                          </div>
                          <div className="impact">
                            Present value of premiums
                          </div>
                        </div>
                        <div className="breakdown-row">
                          <div className="component">
                            Mortality Rate (adjusted)
                          </div>
                          <div className="value">
                            {quote?.breakdown?.mortalityRate || "0.515"} per
                            1000
                          </div>
                          <div className="impact">Death probability</div>
                        </div>
                        <div className="breakdown-row">
                          <div className="component">Health Multiplier</div>
                          <div className="value">
                            {quote?.breakdown?.multipliers?.health || "0.9"}×
                          </div>
                          <div className="impact">
                            {quote?.healthFactors?.healthCondition ||
                              "Excellent"}
                          </div>
                        </div>
                        <div className="breakdown-row">
                          <div className="component">Occupation Multiplier</div>
                          <div className="value">
                            {quote?.breakdown?.multipliers?.occupation || "1"}×
                          </div>
                          <div className="impact">
                            {quote?.healthFactors?.occupationRisk || "Low"}
                          </div>
                        </div>
                        <div className="breakdown-row">
                          <div className="component">Lifestyle Multiplier</div>
                          <div className="value">
                            {quote?.breakdown?.multipliers?.lifestyle || "1"}×
                          </div>
                          <div className="impact">Alcohol & Sports</div>
                        </div>
                        <div className="breakdown-row bmi-row">
                          <div className="component">BMI Multiplier</div>
                          <div className="value">
                            {quote?.breakdown?.multipliers?.bmi || "1.1"}×
                          </div>
                          <div className="impact">
                            <span className="bmi-value">
                              BMI: {quote?.quote?.bmi?.toFixed(2) || "13.07"}
                            </span>
                            <span className="bmi-category warning">
                              (Severely Underweight)
                              <svg
                                className="warning-icon"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" />
                              </svg>
                            </span>
                          </div>
                        </div>
                        <div className="breakdown-row">
                          <div className="component">Add-ons</div>
                          <div className="value">
                            +$
                            {quote?.breakdown?.addons?.toLocaleString(
                              "en-US",
                            ) || "50"}
                            /year
                          </div>
                          <div className="impact">Riders & Benefits</div>
                        </div>
                        <div className="breakdown-row">
                          <div className="component">Discounts</div>
                          <div className="value">
                            -{quote?.breakdown?.discountPercent || "3"}%
                          </div>
                          <div className="impact">Marital, Income</div>
                        </div>

                        <div className="breakdown-total">
                          <div className="component">Annual Premium</div>
                          <div className="value">
                            $
                            {quote?.quote?.premiums?.annual?.toLocaleString(
                              "en-US",
                            ) || "74.04"}
                          </div>
                          <div className="impact">Total / year</div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Card 3: Important Disclosure */}
              <div className="disclosure-card">
                <div
                  className="card-header"
                  onClick={() => setShowDisclosure(!showDisclosure)}
                >
                  <div className="card-title">
                    {/* <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
                        fill="currentColor"
                      />
                    </svg> */}
                    <Info />
                    Important Disclosure
                  </div>
                  <svg
                    className={`chevron ${showDisclosure ? "expanded" : ""}`}
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>

                {showDisclosure && (
                  <div className="card-content">
                    <p>
                      The life insurance quote shown on this page is an estimate
                      only and is provided for informational purposes. Map My
                      Pay, LLC is not an insurance company and does not sell,
                      underwrite, or bind life insurance policies. Final
                      premiums, eligibility, and policy terms are determined
                      solely by the licensed insurance agent or broker who
                      contacts you and by the underwriting insurance carrier.
                      Coverage is not effective until a carrier approves your
                      application and issues a policy.
                    </p>
                    <p>
                      For full disclosures and methodology,{" "}
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleOpenPdf();
                        }}
                        className="disclosure-link"
                      >
                        visit our Life Insurance Disclosures page.
                      </a>
                    </p>
                  </div>
                )}
              </div>

              <PaywallSheet
                show={showExportModal}
                onCancel={() => setShowExportModal(false)}
              />
            </div>
          </div>
        </Row>
      </div>
    </>
  );
};

export default LifeInsurance;
